import { CHANGE_ORDER_LINES, CHANGE_CUSTOMER_DETAIL, SET_CUSTOMERPICKUP_ORDER_DETAILS, CHANGE_SELECTED_ITEMS , SET_WARRANTY_FOR_SLIP} from "../ActionTypes";
const changeOrderLines = (obj: any) => {
    return {
        type: CHANGE_ORDER_LINES,
        payLoad: obj
    };
}
const changeCustomerDetails = (obj: any) => {
    return {
        type: CHANGE_CUSTOMER_DETAIL,
        payLoad: obj
    }
}

const setOrderDetails = (obj: any) => {

    return {
        type: SET_CUSTOMERPICKUP_ORDER_DETAILS,
        payLoad: obj
    }

}
const changeSelectedItem = (obj: any) => {
    return {
        type: CHANGE_SELECTED_ITEMS,
        payLoad: obj
    }

}

const setWarrantyForSlip = (obj: any) => {
  return {
    type: SET_WARRANTY_FOR_SLIP,
    payLoad: obj,
  };
};

const customerPickupActions = {
    changeOrderLines,
    changeCustomerDetails,
    setOrderDetails,
    changeSelectedItem,
    setWarrantyForSlip
}

export default customerPickupActions;